/**
 * Страницы, которые открываются без входа в кабинет.
 *
 * На них протухшая сессия не должна уводить на страницу входа: кабинет при
 * запуске проверяет сохранённый токен, получает 401 и раньше перебрасывал на
 * /login с любой страницы. Человек, открывший ссылку подтверждения почты из
 * письма, вместо результата видел форму входа.
 */
export const PUBLIC_PATHS = ['/login', '/confirmation', '/widget', '/pay3', '/pay4', '/PayTransfer', '/npay'];

export function isPublicPath(pathname) {
    if (!pathname) return false;

    return PUBLIC_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
}



// WEBPACK FOOTER //
// ./src/Services/publicPaths.js